var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"list-group-item",on:{"click":function($event){return _vm.toggleBalInfos(_vm.groupKey, _vm.item.id)}}},[_c('span',{directives:[{name:"handle",rawName:"v-handle"}],staticClass:"handle mr-2"}),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }